export default __webpack_public_path__ + "static/media/karate-kick.14499ee2.png";